import s from "styled-components";
import { SectHead } from "../styled";
import { Row as BootstrapRow } from "reactstrap";
import Paper from "_c/Paper";

export const BlockContainer = s.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1000px;
  margin: 0 auto;
  @media(max-width: 991px) {
    flex-direction: column;
    align-items: center;
  }
`;
export const Block = s(Paper)`
  padding: 40px;
  width: 400px;
  margin: 40px;
  @media(max-width: 991px) {
    margin: 20px 0;
  }
  @media(max-width: 450px) {
    width: 95vw;
    padding: 20px;
  }
`;
export const BlockHead = s.h3`
  font-weight: 400;
  font-size: 24px;
  color: ${({ color }) => color};
  text-align: center;
  margin: 0;
`;
export const Line = s.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
  margin-bottom: 40px;
`;
export const Wrap = s.div`
  margin-top: 110px;
  @media(max-width: 500px) {
    margin-top: 60px;
  }
`;
export const List = s.ul`
  display: flex;
  flex-direction: column;
  li {
    color: var(--font-color-main);
    margin-bottom: 20px;
    :last-child {
      margin: 0;
    }
  }
`;
export const Head = s(SectHead)`
  margin-bottom: 30px;
`;
export const Row = s(BootstrapRow)`
  justify-content: center;
  @media(max-width: 1200px) {
    justify-content: flex-start;
  }
`;
